import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import classnames from 'classnames';
import './IconRightElementForInput.scss';

type Props = {
  className?: string;
  htmlFor?: string;
  icon: IconProp;
  onClick?: any;
};

/**
 * Komponenta pro vykreslení ikonky na pravé straně inputu
 * @param className
 * @param htmlFor
 * @param icon
 * @constructor
 */
export const IconRightElementForInput: React.FC<Props> = ({
  className,
  htmlFor,
  icon,
  ...other
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={classnames('final-form-input-right', className)}
    >
      <FontAwesomeIcon
        icon={icon}
        className={'final-form-input-icon'}
        {...other}
      />
    </label>
  );
};
